import React, {useState, useEffect, useMemo} from 'react'
import './HistoryScreen.css';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import axios from 'axios';
import { mainUrl } from './url';
import { useAuth } from '../Auth';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ModeEditTwoTone } from '@mui/icons-material';

function AdminHistoryScreen() {
    const {selLotteryDate, userType} = useAuth()
    var selDate = selLotteryDate.date
    var selDayPart = selLotteryDate.datePart
    const navigate = useNavigate();
    const [history, setHistory] = useState([])
    const [username, setUsername] = useState('')
    const [users, setUsers] = useState([])

    const [updateHis, setUpdateHis] = useState(0)
    const [delMes, setDelMes] = useState('')
    const [open, setOpen] = React.useState(false);
    const [defineId, setDefineId] = useState('')

    const handleClickOpen = (id) => {
        setOpen(true);
        setDefineId(id)
    };
    const handleClose = () => {
        setOpen(false);
    };
    const useNewHistory = (history) => {
        return useMemo(() => {
          if (!history || history.length === 0) return [];
      
          return history.filter((his) => {
            return his?.buy === '2';
          });
        }, [history]);
    };
    var newHistory = useNewHistory(history)
    const deleteHistory = async(id) => {
      if(id !== ''){
          let delUrl = mainUrl+'api.php?op=deleteHistory&id='+id
          await axios({
            method: 'get',
            url: delUrl
          }).then(async() => {
              setDelMes('ဝယ်ဂဏန်း ဖျက်ပီးပါပီ')
              setUpdateHis(updateHis+1)
              setOpen(false)
          })
      }
    }
    
    useEffect(() => {
		let isSubscribed = true;
        if(isSubscribed){
            (async function(){
                try{
                    await axios.all([
                      axios({
                        method:'get',
                        url: mainUrl+'api.php?op=saveHistory&userid='+username+'&adminid='+userType?.id+'&date='+selDate+'&part='+selDayPart
                      }),
                      axios({
                        method:'get',
                        url: mainUrl+'api.php?op=userall&adminid='+userType?.id
                      })
                    ]).then(response => {
                        setHistory(response?.[0]?.['data']['data']['result'])
                        setUsers(response?.[1]?.['data']['data']['result'])
                    })
                } catch (error) {
                    
                }
            })()
        }
		return () => {isSubscribed = false}
    }, [username, updateHis, userType?.id, selDate, selDayPart])

    const handleClickEdit = (id) => {
      var historyDetail = history?.filter((history) => history?.id === id)
      navigate('/buyedit',{
        state:{
          success:true,
          id:id,
          message:historyDetail?.[0]?.result + ' ဝယ်ကွက်အား ပြင်ဆင်ရန်',
          date: historyDetail?.[0]?.date,
          username:username
        }
      })
    }
    return (
         <div
        style={{marginTop:-10,
        justifyContent:'center', paddingLeft:5, paddingBottom:10, overflow:'scroll',
        alignItems:'start'}}
        >
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
          {"ဝယ်ဂဏန်း ဖျက်ရန်"}
          </DialogTitle>
          <DialogContent>
          <DialogContentText id="alert-dialog-description">
              ဝယ်ဂဏန်းများနှင့် ပမာဏကို ဖျက်ရန် သေချာလား?
          </DialogContentText>
          </DialogContent>
          <DialogActions>
          <Button onClick={handleClose}>မဖျက်ပါ</Button>
          <Button onClick={() => deleteHistory(defineId)}>
              ဖျက်မည်
          </Button>
          </DialogActions>
        </Dialog>
        <div style={{width:'500px', paddingTop:5}}>
            <div className='historytitle'>
                <Button className='historylink' onClick= {() => navigate('/adminbuy')}>
                    <ArrowBackIosIcon color='black' 
                    style={{color:'black', 
                    }}/>
                </Button>
                <p style={{fontFamily:'mmfont'}}>ဝယ်ပြီး အကွက်များ</p>
            </div>
            <p style={{fontSize:15, color:'green', marginTop:delMes!==''?3:0, paddingLeft:8}}>{delMes}</p>
            <div className='historytitle'>
                <p style={{marginRight:28}}>Agent </p>
                <Select
                size='small'
                sx={{
                  height:30,
                  width:150,
                  color: "white",
                  '.MuiOutlinedInput-notchedOutline': {
                    borderColor: 'white',
                    border:'2px solid white'
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'white',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'white',
                  },
                  '.MuiSvgIcon-root ': {
                    fill: "white !important",
                  }
                }}
                labelId="select-user"
                id="select-user"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                >
                  {
                    users?.sort((a,b) => a?.username.localeCompare(b?.username))?.map((user, index) => 
                    <MenuItem key={index} value={user?.id}>{user?.username}</MenuItem>
                    )
                  }
                </Select>
            </div>
            <table className='tablehead' style={{backgroundColor:'white', width:'500px !important', overflow:'scroll !important'}}>
              <tbody>
                {
                  newHistory?.map((his,index) => (
                      <>
                      {index === 0 && <tr>
                      <td style={{textAlign:'center', color:'white', width:'50px', fontFamily:'textfont', backgroundColor:'#6798c6'}} className='tablebox'>SN</td>
                      <td style={{textAlign:'center', color:'white', width:'190px', lineHeight:2, fontFamily:'mmfont', backgroundColor:'#6798c6'}} className='tablebox'>ဝယ်ပီး ဂဏန်းများ</td>
                      <td style={{extAlign:'center', color:'white', lineHeight:2, fontFamily:'mmfont', backgroundColor:'#6798c6'}}>
                        <p style={{fontFamily:'mmfont', width:'160px'}}>ဝယ်ခဲ့သော အချိန် </p></td>
                      <td style={{textAlign:'center', color:'white', width:"100px", lineHeight:2, fontFamily:'mmfont', backgroundColor:'#6798c6'}}>Edit</td>
                      <td style={{textAlign:'center', color:'white', width:"50px", lineHeight:2.5, fontFamily:'textfont', backgroundColor:'#6798c6', marginTop:-1}} className='tablebox'>Del</td>
                    </tr>}
                    <tr style={{backgroundColor:'white'}}>
                        <td style={{fontSize:15, textAlign:'center', color:'black', border:'1px solid #6798c6'}}>
                        <p style={{fontFamily:'textfont', lineHeight:2, width:'50px', paddingTop:3}}>{index+1}
                        </p>
                        </td>
                        <td style={{fontSize:15, justifyContent:'left', alignItems:'left', textAlign:'left !important', paddingLeft:3, paddingRight:3, fontFamily:'textfont', border:'1px solid #6798c6'}}>
                        <p style={{whiteSpace:'nowrap', minWidth:'118px'}}>
                          {his?.result}
                        </p>
                        </td>
                        <td style={{fontSize:15, textAlign:'center', fontFamily:'textfont', border:'1px solid #6798c6'}} >
                          <p style={{whiteSpace:'nowrap', width:'170px', textAlign:'center'}}>{his?.date?.split(' ')?.[0]?.split('T')?.[0]+' '+his?.date?.split(' ')?.[0]?.split('T')?.[1]}</p>
                        </td>
                        <td style={{width:'50px', border:'1px solid #6798c6'}}>
                          <p style={{textAlign:'center', width:'50px'}}>
                            <ModeEditTwoTone
                              onClick={() => handleClickEdit(his?.id)}
                            />
                          </p>
                        </td>
                        <td style={{width:'50px', border:'1px solid #6798c6'}}>
                          <p style={{textAlign:'center', width:'50px'}}>
                            <DeleteTwoToneIcon 
                              onClick={() => handleClickOpen(his?.id)}
                            />
                          </p>
                        </td>
                    </tr>
                      </>
                  ))
                }
              </tbody>
            </table>
            
        </div>
        </div>
    )
}

export default AdminHistoryScreen